import client from "./client";

const register = (userInfo) => {
  console.log(userInfo);
  // delete userInfo.confirmPassword;
  const data = new FormData();
  data.append("user_name", userInfo.user_name);
  data.append("email", userInfo.email);
  data.append("password", userInfo.password);
  data.append("user_city", userInfo.user_city);
  data.append("user_country", userInfo.user_country);
  data.append("user_zip", userInfo.user_zip);
  return client.post("/user/m.signup.php", data);
};

export default { register };
